import { Link, useLocation } from "wouter";
import { Navigation } from "../../components/navigation/Navigation";
import { SectionInfo } from "../../components/section-info/SectionInfo";
import { CategoriesTop } from "../../shared/categories-top/CategoriesTop";
import Footer from "../../shared/footer/Footer";
import { HowUse } from "../../shared/how-use/HowUse";
import { ProviderTop } from "../../shared/provider-top/ProviderTop";
import "./Home.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { api } from "../../settings/env";
import Preloader from "../../components/Preloader/Preloader";
import SearchBar from "../../components/SearchBar/SearchBar";

export function Home() {



    const [location, setLocation] = useLocation();
    const [device, setDevice] = useState("");
    const [data, setData] = useState("");
    const [userName, setUserName] = useState("");
    const [loginStatus, setLoginStatus] = useState(true);
    const inputSearch = useRef();

    const search = () => {
        // TODO: Implement search functionality
        setLocation("search");
    }

    const searchProfessional = (e) => {
        console.log("Search.. ", inputSearch.current.value);

        if (inputSearch.current.value != "") {
            searching(inputSearch.current.value);
        } else {
            setData("");
        }

    }

    const searching = (value) => {
        axios.get(`${api}/register/search/${value}`)
            .then(response => {
                setData(response.data)
            })
            .catch(error => console.error(error));
    }

    const getUser = (user) => {
        axios.get(`${api}/register/professional-info/${user}`)
            .then(response => {
                console.log("User info", response.data.data);
                localStorage.setItem("vitaly_user", JSON.stringify(response.data.data));
                setUserName(response.data.data.fullName.split(" ")[0]);
                console.log(response.data.data.fullName.split(" ")[0]);
                //setLocation(`/provider/${response.data.data._id}`);
            })
            .catch(error => console.error(error));
    }

    //
    useEffect(() => {
        const userId = localStorage.getItem("vitaly_userid");
        console.log("userId: " + userId);
        if (userId && userId !== undefined && userId !== 'undefined') {
            setLoginStatus(true);
            getUser(userId);

        } else {
            setLoginStatus(false);
        }
    }, [])

    return (
        <div>
            <Navigation
                login={loginStatus}
                userName={userName}
            />

            <Preloader />
            <div style={{ height: "80px" }}></div>

            <div className="cover-hero">

                <div className="content">
                    <h1 className="text-center">
                        Tu salud, más cerca que nunca.
                    </h1>

                    <p className="text-center">
                        Descubre todos los espacios que benefician tu bienestar en un solo lugar.
                    </p>

                    <SearchBar />
                </div>

                <div className="banner-hero">
                    <div className="content-banner">

                        <div className="balls">
                            <div className="active"></div>
                            <div></div>
                            <div></div>
                        </div>
                        <p>Encuentra lo ideal para tu bienestar.</p>
                        <h2>Tu salud es tu mayor prioridad</h2>

                        <div className="call-btn">
                            Buscar profeisonales

                            <button className="btn btn-secondary">
                                <img src="/assets/icons/right-arrow.svg" alt="" />
                            </button>
                        </div>
                    </div>

                    <img src="/assets/images/HERO.webp" alt="" />
                </div>
            </div>

            <div style={{ height: "500px" }}></div>

            <ProviderTop />

            <div className="container">
                <div className="banner">

                </div>

            </div>


            <CategoriesTop />

            <div className="container">
                <div className="banner" style={{ background: "#f4e200" }}>

                </div>

            </div>

            <HowUse />

            <SectionInfo />
            <Footer />

        </div>
    );
}